export default function removerMascaraValores(string: string) {
  return string.replace(/[^\d]/g, '');
}
